export const LIVEAVATAR_START_PAYLOAD_ERROR_CODE =
  "LIVEAVATAR_START_PAYLOAD_INVALID";
export const LIVEAVATAR_TOKEN_EMPTY_RESPONSE_ERROR_CODE =
  "LIVEAVATAR_TOKEN_EMPTY_RESPONSE";
export const LIVEAVATAR_TOKEN_REQUEST_ERROR_CODE =
  "LIVEAVATAR_TOKEN_REQUEST_ERROR";
export const LIVEAVATAR_MICROPHONE_PERMISSION_ERROR_CODE =
  "LIVEAVATAR_MICROPHONE_PERMISSION_REQUIRED";

export class LiveAvatarStartPayloadError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = "LiveAvatarStartPayloadError";
    this.code = LIVEAVATAR_START_PAYLOAD_ERROR_CODE;
    this.details = details;
  }
}

export class LiveAvatarTokenError extends Error {
  constructor(code, message, details = {}) {
    super(message);
    this.name = "LiveAvatarTokenError";
    this.code = code;
    this.details = details;
  }
}

const pickFirstString = (values) => {
  for (const value of values) {
    if (typeof value === "string" && value.trim() !== "") {
      return value;
    }
  }

  return null;
};

export const normalizeLiveAvatarStartResponse = (rawStartResponse) => {
  const startData = rawStartResponse?.data || rawStartResponse || {};

  const livekitUrl = pickFirstString([
    startData?.livekit_url,
    startData?.livekitUrl,
    startData?.livekit_server_url,
    startData?.livekitServerUrl,
    startData?.livekit_ws_url,
    startData?.livekitWsUrl,
    startData?.room_url,
    startData?.roomUrl,
    startData?.rtc_url,
    startData?.rtcUrl,
    startData?.url,
    startData?.livekit?.url,
    startData?.livekit?.server_url,
    startData?.livekit?.serverUrl,
    startData?.livekit_client?.url,
    startData?.livekitClient?.url,
  ]);

  const livekitToken = pickFirstString([
    startData?.livekit_token,
    startData?.livekitToken,
    startData?.livekit_client_token,
    startData?.livekitClientToken,
    startData?.room_token,
    startData?.roomToken,
    startData?.rtc_token,
    startData?.rtcToken,
    startData?.access_token,
    startData?.accessToken,
    startData?.token,
    startData?.livekit?.token,
    startData?.livekit?.client_token,
    startData?.livekit?.clientToken,
    startData?.livekit_client?.token,
    startData?.livekitClient?.token,
  ]);

  if (!livekitUrl || !livekitToken) {
    throw new LiveAvatarStartPayloadError(
      "LiveAvatar start response does not contain required LiveKit data",
      {
        availableKeys: Object.keys(startData || {}),
        hasLivekitUrl: Boolean(livekitUrl),
        hasLivekitToken: Boolean(livekitToken),
      },
    );
  }

  return {
    startData,
    livekitUrl,
    livekitToken,
    sessionId: pickFirstString([
      startData?.session_id,
      startData?.sessionId,
      startData?.session?.id,
      startData?.session?.session_id,
      startData?.data?.session_id,
      startData?.data?.sessionId,
      rawStartResponse?.session_id,
      rawStartResponse?.sessionId,
    ]),
  };
};
